// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CNd2","type":"styles_type__3O1Ys","choices":"styles_choices__l8n8a"};